/**********************************************************
Chemical Form
**********************************************************/
import { TextInput, NumberInput, Select, FileButton } from '../inputs';
import { CHEMICAL_TYPES, YES_OR_NO, UNITS_OF_MEASURE } from '../../cult_constants';
import { CREATE_CHEMICAL, EDIT_CHEMICAL } from '../../actions/types';
import { packageForm } from '../../cult_utils';
import React, { Component } from 'react';

class ChemicalForm extends Component {
  render() {
    return (
      <form className="chem-container" id={'chemical-form'} onSubmit={(e) => e.preventDefault()}>
        <div className="row">
          <div className="col s12 m6 l6 xl6">
            <TextInput id={'chemical-name'} label={'Brand Name'} placeholder={'Goal XL, Herbimax, etc '} required={true} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <TextInput id={'chemical-ingredients'} label={'Ingredients'} placeholder={'Glyphosate, etc'} required={true} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <Select id={'chemical-type'} opts={CHEMICAL_TYPES} label={'Type'} required={true} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <Select id={'chemical-hawaiiRegistration'} opts={YES_OR_NO} label={'Hawaii Registration'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <TextInput id={'chemical-epaNo'} label={'EPA#'} placeholder={'56-1234-56'} required={true} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <TextInput id={'chemical-manufacturer'} label={'Manufacturer'} placeholder={'DuPont Crop Protection'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <NumberInput id={'chemical-rei'} label={'Restricted Entry Interval (REI)'} min={"0"} max={"120"} step={"0.1"} required={true} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <NumberInput id={'chemical-preHarvestInterval'} label={'Pre-Harvest Interval'} min={"0"} max={"120"} step={"0.1"} required={true} />
          </div>
        </div>
        <span className="reco-dosage">Recommended Dosage</span>
        <div className="row">
          <div className="col s2 m2 l2 xl2">
            <NumberInput id={'chemical-recoDosage1'} label={'Quantity'} min={"0"} max={"5000"} step={"0.1"} />
          </div>
          <div className="col s3 m3 l3 xl3">
            <Select id={'chemical-recoDosage2'} label={'Unit'} opts={UNITS_OF_MEASURE} />
          </div>
          <div className="col s1 m1 l1 xl1"><h3>/</h3></div>
          <div className="col s2 m2 l2 xl2">
            <NumberInput id={'chemical-recoDosage3'} label={'Quantity'} min={"0"} max={"5000"} step={"0.1"} />
          </div>
          <div className="col s3 m3 l3 xl3">
            <Select id={'chemical-recoDosage4'} label={'Unit'} opts={UNITS_OF_MEASURE} />
          </div>
        </div>
        <div className="row">
          <div className="col s2 m3 l3 xl3">
            <NumberInput id={'chemical-maxQuantity'} label={'Max Quantity(Acre/Year)'} min={"0"} max={"5000"} step={"0.1"} />
          </div>
          <div className="col s3 m3 l3 xl3">
            <Select id={'chemical-maxQuantityUnit'} label={'Unit'} opts={UNITS_OF_MEASURE} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <TextInput id={'chemical-url'} label={'Product URL'} placeholder={'https://www.greenbook.net/syngenta-llc/aatrex-nine-o'} />
          </div>
          { this.props.isEditing ?
              <div className="col s12 m12 l12 xl12">
              <p className="edit-file-list">
                <u><b>Current Files</b></u><br />
                <b>Label:</b> { this.props.editedChemical.label }<br />
                <b>SDS:</b> { this.props.editedChemical.sds }<br />
                <b>Supp.Label:</b> { this.props.editedChemical.supplementalLabel }<br />
                <b>SLNL:</b> { this.props.editedChemical.specialLocalNeedsLabel }<br />
              </p>
              </div>
            : ''
          }
          <div className="col s12 m6 l6 xl6">
            <FileButton id={'chemical-label'} name={'chemical-label'} label={'Product Label'} _class={'file-btn-label'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <FileButton id={'chemical-sds'} name={'chemical-sds'} label={'Safety Data Sheet'} _class={'file-btn-label'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <FileButton id={'chemical-supplementalLabel'} name={'chemical-supplementalLabel'} label={'Supplemental Label'} _class={'file-btn-label'} />
          </div>
          <div className="col s12 m6 l6 xl6">
            <FileButton id={'chemical-specialLocalNeedsLabel'} name={'chemical-specialLocalNeedsLabel'} label={'Special Local Needs Label'} _class={'file-btn-label'} />
          </div>
        </div>
        <center>
          {
            this.props.isEditing ?
              <div className="row">
                <div className="col s6 m6 l6 xl6">
                  <button className="btn waves-effect blue"
                    onClick={() => this.props.createOrEditChemical(packageForm('chemical-form'),
                      this.props.eid, EDIT_CHEMICAL, 'editChemical', this.props.editedChemical)}>
                    Edit Product
                  </button>
                </div>
                <div className="col s6 m6 l6 xl6">
                  <button onClick={() => this.props.clearForm('chemical-form')}
                  className="btn waves-effect flat">Clear Form</button>
                </div>
              </div>
            : <button onClick={() => this.props.createOrEditChemical(packageForm('chemical-form'), this.props.eid, CREATE_CHEMICAL, 'createChemical')}
              className="btn waves-effect">Create New Product</button>
          }
        </center>
      </form>
    );
  }
}

export default ChemicalForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chemical/chemical_form.js